module.exports = __webpack_public_path__ + "static/media/menuHotspot-active.223b4727.svg";